module.exports = __webpack_public_path__ + "img/英文-首屏头图.eafe2f89.jpg";